import { createContext, useContext } from "react";

type HelpActionBase = {
  id: string;
  routeIds: string[];
};

type HelpActionLink = {
  to: string;
} & HelpActionBase;

type HelpActionTrigger = {
  onClick: () => void;
} & HelpActionBase;

export type HelpAction = HelpActionLink | HelpActionTrigger;

export type HelpActionsContextValues = {
  addHelpAction: (props: HelpAction) => void;
  helpActions: HelpAction[];
  activeHelpAction: HelpAction | null;
};

export const HelpActionsContext = createContext<
  HelpActionsContextValues | undefined
>(undefined);

export const useHelpActions = () => {
  const context = useContext(HelpActionsContext);

  if (context === undefined) {
    throw new Error(
      "useHelpActions must be inside a HelpActionsContextProvider"
    );
  }

  return context;
};
